import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Container } from "react-bootstrap";
import { Grid } from "@mui/material";
import { Skeleton } from "@material-ui/lab";

import {
  gradeApi,
  interestApi,
  profileApi,
  userProfileApi,
} from "../../../utility/api/apiList";

import useAxios from "../../../hooks/useAxios";
import userType from "../../../redux/actions/user/userType";

import {
  showDangerAlert,
  showInfoAlert,
} from "../../../redux/actions/alert/alertActions";

import scrollToTop from "../../../libs/scrollToTop";

import UserChangeInfComponent from "../../../components/private/user/userChangeInfComponent";
import {
  ImageProvider,
  InfoContainer,
} from "../../../components/private/user/userChangeInfComponent/styledUserChangeInfComponent";

export default function UserChangeInfContainer() {
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.userDetail);

  const [formError, setFormError] = useState(null);
  const [imageUrl, setImageUrl] = useState(
    userDetail?.userDetail[0]?.usermeta?.img_addr
  );

  const defaultSchoolName = userDetail.userDetail[0].usermeta.school_name;

  const userInitData = {
    first_name: userDetail.userDetail[0].first_name,
    last_name: userDetail.userDetail[0].last_name,
    email: userDetail.userDetail[0].email,
    nid: userDetail.userDetail[0].usermeta.nid,
    gender: userDetail.userDetail[0].usermeta.gender,
    grade: userDetail.userDetail[0].usermeta.grade,
    school_name: defaultSchoolName ? defaultSchoolName : "",
    type: userDetail.userDetail[0].usermeta.type,
    interest: userDetail.userDetail[0].usermeta.interest,
  };

  const { isLoading: imageIsLoading, run: imageUploadRun } = useAxios({
    url: userProfileApi,
    method: "put",
  });

  const { isLoading: infoIsLoading, run: infoUploadRun } = useAxios({
    url: profileApi,
    method: "put",
  });

  const {
    data: grades,
    errors: gradesError,
    isLoaded: gradeIsLoaded,
    run: gradeRun,
  } = useAxios({
    url: gradeApi,
  });

  const {
    data: interest,
    errors: interestError,
    isLoaded: interestIsLoaded,
    run: interestRun,
  } = useAxios({
    url: interestApi,
  });

  useEffect(() => {
    document.title = "تغییر اطلاعات کاربری";
    scrollToTop();
    gradeRun();
    interestRun();
  }, []);

  const handleChangePhoto = (data) => {
    const blob = new Blob([data.img_addr[0]]);
    const url = URL.createObjectURL(blob);
    if (imageUrl === url) return;
    let formData = new FormData();
    formData.append("img_addr", data.img_addr[0]);
    imageUploadRun(formData)
      .then(() => {
        setImageUrl(url);
        dispatch({ type: userType.UPDATE_USER_DETAIL });
        dispatch(showInfoAlert("ویرایش عکس با موفقیت انجام شد."));
      })
      .catch(() => {
        dispatch(showDangerAlert("ویرایش عکس با خطا مواجه شد."));
      });
  };

  const handleChangeInfo = (data) => {
    const { grade, nid, school_name, role, interest, gender, ...items } = data;
    const dataShouldSent = {
      ...items,
      usermeta: {
        grade: grade ? grade.value : null,
        nid,
        school_name,
        type: role ? role.value : null,
        gender: gender ? gender.value : null,
        interest: interest ? interest.map((item) => item.value) : [],
      },
    };
    infoUploadRun(dataShouldSent)
      .then(() => {
        dispatch({ type: userType.UPDATE_USER_DETAIL });
        dispatch(showInfoAlert("ویرایش اطلاعات شما با موفقیت انجام شد."));
      })
      .catch((error) => {
        dispatch(showDangerAlert("ویرایش اطلاعات شما با خطا مواجه شد"));
        setFormError(error);
      });
  };

  const UserChangeInfSkeleton = () => {
    return (
      <InfoContainer className="d-flex flex-column align-items-center">
        <ImageProvider className="mb-5"></ImageProvider>
        <Grid container spacing={2} sx={{ width: "100%" }}>
          {Object.keys(userInitData).map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Skeleton className="w-100" height="65px" />
            </Grid>
          ))}
        </Grid>
      </InfoContainer>
    );
  };

  let element = null;
  const error = interestError || gradesError;

  if (!gradeIsLoaded || !interestIsLoaded) {
    element = <UserChangeInfSkeleton />;
  } else if (error) {
    element = <p className="text-center p-5">{error}</p>;
  } else {
    element = (
      <UserChangeInfComponent
        imageUrl={imageUrl}
        loading={infoIsLoading}
        imageIsLoading={imageIsLoading}
        handleChangePhoto={handleChangePhoto}
        handleChangeInfo={handleChangeInfo}
        grades={grades?.results}
        interests={interest?.results}
        defaultData={userInitData}
        formError={formError}
      />
    );
  }
  return <Container>{element}</Container>;
}
